import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatError } from "@/lib/api";
import { SiteView } from "@/components/site/SiteView";
import { SiteLoading } from "./PublicSite";

export default function PreviewSite() {
  const [content, setContent] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get("/admin/preview").then((r) => setContent(r.data)).catch((e) => setError(formatError(e)));
  }, []);

  if (!content) return <SiteLoading error={error} />;
  return (
    <>
      <div className="fixed top-0 inset-x-0 z-[45] h-9 bg-[#C5A059] text-[#08080A] text-[0.65rem] sm:text-xs uppercase tracking-[0.2em] flex items-center justify-center gap-4" data-testid="preview-banner">
        Pré-visualização do rascunho — ainda não publicado
        <Link to="/admin" className="underline underline-offset-4" data-testid="preview-back-admin-link">Voltar ao painel</Link>
      </div>
      <SiteView content={content} headerTop={36} />
    </>
  );
}
